const initSpoilers = () => {
  let spollers = document.querySelectorAll('._spoller:not(.spoller-init)');
  let spollersGo = true;

  // SlideToggle
  const slideUp = (target, duration = 500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = `${duration}ms`;
    target.style.height = `${target.offsetHeight}px`;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      target.classList.remove('_slide');
    }, duration);
  };
  const slideDown = (target, duration = 500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') { display = 'block'; }

    target.style.display = display;
    const height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = `${duration}ms`;
    target.style.height = `${height}px`;
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      target.classList.remove('_slide');
    }, duration);
  };
  const slideToggle = (target, duration = 500) => {
    if (!target.classList.contains('_slide')) {
      target.classList.add('_slide');
      if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration);
      }
      return slideUp(target, duration);
    }
    return false;
  };

  if (spollers.length > 0) {
    const spollerCLick = (e) => {
      const spoller = e.target;
      if (spollersGo) {
        spollersGo = false;

        if (spoller.closest('._spollers').classList.contains('_one')) {
          const curentSpollers = spoller.closest('._spollers').querySelectorAll('._spoller');
          for (let i = 0; i < curentSpollers.length; i++) {
            const el = curentSpollers[i];
            if (el !== spoller) {
              el.classList.remove('_active');
              slideUp(el.nextElementSibling);
            }
          }
        }
        spoller.classList.toggle('_active');
        slideToggle(spoller.nextElementSibling);

        setTimeout(() => {
          spollersGo = true;
        }, 500);
      }
    };
    const spollersInit = () => {
      for (let index = 0; index < spollers.length; index++) {
        if (!spollers[index].classList.contains('.spoller-init')) {
          spollers[index].classList.add('spoller-init');
          const spoller = spollers[index];
          const spollerMax = spoller.getAttribute('data-max');
          if (spollerMax && window.innerWidth > spollerMax) {
            if (spoller.classList.contains('_init')) {
              spoller.classList.remove('_active');
              spoller.classList.remove('_init');
              spoller.nextElementSibling.style.cssText = '';
              spoller.removeEventListener('click', spollerCLick);
            }
          } else if (!spoller.classList.contains('_init')) {
            spoller.classList.add('_init');
            spoller.addEventListener('click', spollerCLick);
          }
        }
      }
    };
    const spollersShowActive = () => {
      for (let index = 0; index < spollers.length; index++) {
        const spoller = spollers[index];
        if (spoller.classList.contains('_active')) {
          if (spoller.classList.contains('_default-hide')) {
            return false;
          }
          slideToggle(spoller.nextElementSibling);
        }
      }
      return null;
    };
    window.addEventListener('resize', spollersInit);

    setTimeout(() => {
      spollersShowActive();
      spollersInit();
    }, 0);

    const spollerUpd = () => {
      spollers = document.querySelectorAll('._spoller:not(.spoller-init)');
      spollersInit();
    };

    window.spollerUpd = spollerUpd;
  }
};

initSpoilers();
